import './style.sass';

import React from 'react';

import BannerCaseNav from './banner-case-nav';
import BannerCaseRule from './banner-case-rule';

const BannerCase = ({ img, video, className = '', listPath }) => {
    return (
        <div className="banner-case">
            <BannerCaseRule video={video} img={img} />
            <BannerCaseNav className={className} listPath={listPath} />
        </div>
    );
};

export default BannerCase;
